import type { EnumUnion } from "@dresscode-frontend/utility-types";

export const DeviceGenre = {
  LAPTOP: "LAPTOP",
  WORKSTATION: "WORKSTATION",
  MONITOR: "MONITOR",
  MOBILE: "MOBILE",
  TABLET: "TABLET",
  SERVER: "SERVER",
  OTHER: "OTHER",
} as const;

export type DeviceGenre = EnumUnion<typeof DeviceGenre>;
